import __C from '../../../../../../includes/primitives/_constant_'

export default {
    Canvas: {
      CanvasWidth: 530,
      CanvasHeight: 180,
      CanvasBorderWeight: 0.3,
      CanvasBorderColor: 'Transparent',
      CanvasFillColor: 'Transparent',
      CanvasOpacity: 0.2,

      CanvasChartX: 0,
      CanvasChartY: 0,
      CanvasChartWidth: 310,
      CanvasChartHeight: 270,
      CanvasChartBorderWeight: 0,
      CanvasChartBorderColor: 'Transparent',
      CanvasChartFillColor: 'Transparent',
      CanvasChartOpacity: 0,
      CanvasChartSpace: 0,

      CanvasFontFamily: 'roboto',
    },

     // ----------------------------------------------- NOTE
    Note: {
      NoteDisplay: 'N',
      NoteX: 50,
      NoteY: 420,
      NoteAlign: 'start',
      NoteTitleText: 'Notes.',
      NoteTitleFont: 'roboto',
      NoteTitleStyle: 'regular',
      NoteTitleSize: 11,
      NoteTitleColor: '#757575',

      NoteContentsText: 'Note Contents Here!',
      NoteContentsFont: 'roboto',
      NoteContentsStyle: 'regular',
      NoteContentsSize: 10,
      NoteContentsColor: '#BDBCBC',
    },

    Text: {
      Text: [],
      Filter: [],
      Sql: []
    },

    DataItems: [
      {ITEM:"Structure",PAUT_TEST_LEN:26254972,PAUT_REPAIR_LEN:189263,PAUT_REPAIR_RATE: 0.72},
      {ITEM:"Pipe",PAUT_TEST_LEN:29740.77,PAUT_REPAIR_LEN:0,PAUT_REPAIR_RATE: 0},
      {ITEM:"TOTAL",PAUT_TEST_LEN:26284712.77,PAUT_REPAIR_LEN:189263,PAUT_REPAIR_RATE: 0.72}
      ],

    Queries: {
    }
}